<template>
    <div class="chat-wrap" v-show="chatShow">
        <div class="chat-top">
            <div class="chat-title">{{info.nickname}}和你的对话</div>
            <div class="close-icon" @click="close">
                <i class="el-icon-close"></i>
            </div>
        </div>
        <div class="chat-center" id="chat">
            <div v-for="item in chatList" :key="item.id">
                <div class="my" v-if="userInfo.uid == item.uid">
                    <div class="content">
                        <p v-if="item.type == 1">{{item.content}}</p>
                        <img :src="item.content" alt="图片加载失败" v-if="item.type == 2" />
                        <video :src="item.content" controls="controls" v-if="item.type == 3"></video>
                    </div>
                    <img :src="item.avatar" class="avatar" alt="图片加载失败" />
                </div>
                <div class="other" v-else>
                    <img :src="item.bavatar" class="avatar" alt="图片加载失败" />
                    <div class="content">
                        <p v-if="item.type == 1">{{item.content}}</p>
                        <img :src="item.content" alt="图片加载失败" v-if="item.type == 2" />
                        <video :src="item.content" controls="controls" v-if="item.type == 3"></video>
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-bottom">
            <div class="bottom">
                <img :src="userInfo.avatar" alt="图片加载失败" />
                <el-input
                    type="textarea"
                    v-model="content"
                    maxlength="200"
                    show-word-limit
                    :autosize="{ minRows: 1, maxRows: 4}"
                ></el-input>
                <i class="el-icon-circle-plus-outline" @click="upShow = !upShow"></i>
            </div>
            <div class="chat-upload" v-show="upShow">
                <UpImgOrVideo :file="video" @getFile="addChangeVideo" />
                <p>提示：文字和图片不能同时发送</p>
            </div>
            <el-button type="primary" class="send" @click="setUserChat">发送</el-button>
        </div>
    </div>
</template>

<script>
    import UpImgOrVideo from '../content/UpImgOrVideo';
    export default {
        props: {
            info: {
                type: Object
            }
        },
        data() {
            return {
                timer: null,
                chatShow: false,
                userInfo: this.$store.state.login.userInfo,
                content: '',
                video: '',
                upShow: false,
                type: 1,
                chatList: []
            };
        },
        computed: {},
        created() {
            this.$once('hook:beforeDestroy', () => {
                clearInterval(this.timer);
                console.log('clearInterval-timer', this.timer);
            });
        },
        mounted() {},
        methods: {
            close() {
                this.chatShow = false;
                this.$emit('close');
                // 通过$once来监听定时器
                // 在beforeDestroy钩子触发时清除定时器
                this.$once('hook:beforeDestroy', () => {
                    clearInterval(this.timer);
                    console.log('clearInterval-timer', this.timer);
                });
            },
            openChat() {
                this.chatList = [];
                this.chatShow = true;
                this.getChatList();
            },
            addChangeVideo(val, type) {
                // type = 1 ->文字，2->视频
                this.type = type == 1 ? 2 : 3; // 1文字 2图片 3视频
                if (val == '') {
                    this.type = 1;
                }
                this.video = val;
                this.img = `${val}?x-oss-process=video/snapshot,t_10000,m_fast`;
            },
            getChatList() {
                this.httpGet(this.$root.getChatList, {
                    buid:
                        this.info.uid ||
                        this.$route.query.buid ||
                        this.$route.query.professor,
                    page: 1,
                    size: 99999
                })
                    .then(result => {
                        if (result.list.length > this.chatList.length) {
                            this.chatList = [];
                            this.chatList.push(...result.list);
                            this.chatList = this.chatList.reverse();
                            // 滚动
                            this.$nextTick(() => {
                                let msg = document.getElementById('chat'); // 获取对象
                                msg.scrollTop = msg.scrollHeight; // 滚动高度
                                console.log(result, msg);
                            });
                        }
                    })
                    .catch(error => {
                        console.error('setUserChat', error);
                        clearInterval(this.timer);
                    });
            },
            setUserChat() {
                if (this.content && this.video) {
                    this.$message({
                        message: '文字和图片不能同时发送',
                        type: 'warning'
                    });
                }
                let content = this.type == 1 ? this.content : this.video;
                if (content == '') {
                    return;
                }
                this.httpPost(this.$root.setUserChat, {
                    content: content,
                    type: this.type,
                    buid:
                        this.info.uid ||
                        this.$route.query.buid ||
                        this.$route.query.professor
                })
                    .then(result => {
                        console.log(result);
                        this.content = '';
                        this.video = '';
                        this.chatList = [];
                        this.getChatList();
                    })
                    .catch(error => {
                        console.error('setUserChat', error);
                        clearInterval(this.timer);
                    });
            }
        },
        watch: {
            info: function(newInfo, oldInfo) {},
            chatShow(newShow, oldShow) {
                if (newShow) {
                    this.timer = setInterval(() => {
                        // 某些定时器操作
                        this.getChatList();
                        console.log('ser-timer', this.timer);
                    }, 5000);
                } else {
                    // this.$once('hook:beforeDestroy', () => {
                    clearInterval(this.timer);
                    console.log('clearInterval-timer', this.timer);
                    // });
                }
            }
        },
        updated() {
            // 聊天定位到底部
            let ele = document.getElementById('chat');
            ele.scrollTop = ele.scrollHeight;
        },
        components: { UpImgOrVideo }
    };
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    @import '~assets/main.styl';

    .chat-wrap {
        width: 880px;
        // height: 719px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
    }

    .chat-top {
        // width: 100%;
        height: 70px;
        border-bottom: 1px solid #F0F0F0;
        position: relative;
        flex-x();
        padding: 0 24px;

        .chat-title {
            width: 98%;
            text-align: center;
        }

        .close-icon {
            position: absolute;
            right: 24px;

            i {
                font-size: 16px;
            }
        }
    }

    .chat-center {
        width: 820px;
        padding: 12px 30px;
        height: 407px;
        overflow-x: hidden;
        overflow-y: scroll;
        -ms-overflow-style: none;

        .avatar {
            width: 48px;
            height: 48px;
            border-radius: 48px;
        }

        .other {
            flex-x(flex-, flex-start);
            margin-bottom: 24px;

            .content {
                max-width: 520px;
                margin-left: 24px;
                padding: 16px;
                background: rgba(244, 244, 244, 1);
                border-radius: 16px;
                border-top-left-radius: 0px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;

                p {
                    color: rgba(0, 0, 0, 0.85);
                }

                img {
                    width: 100%;
                    height: 100%;
                    max-width: 520px;
                    max-height: 580px;
                }

                video {
                    width: 100%;
                    height: 100%;
                    max-width: 520px;
                    max-height: 580px;
                }
            }
        }

        .my {
            flex-x(flex-end, flex-start);
            margin-bottom: 24px;

            .content {
                max-width: 520px;
                padding: 16px;
                // background: rgba(64, 147, 255, 1);
                margin-right: 24px;
                border-radius: 16px;
                border-top-right-radius: 0px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 22px;

                p {
                    background: rgba(64, 147, 255, 1);
                    color: rgba(255, 255, 255, 1);
                    padding: 16px;
                    border-radius: 16px;
                    border-top-right-radius: 0px;
                }

                img {
                    max-width: 520px;
                    max-height: 580px;
                }

                video {
                    max-width: 520px;
                    max-height: 580px;
                }
            }
        }
    }

    .chat-bottom {
        height: 156px;
        overflow-x: hidden;
        overflow-y: scroll;
        border-top: 1px solid #F0F0F0;
        padding: 30px;
        -ms-overflow-style: none;
        position: relative;

        .send {
            position: absolute;
            bottom: 30px;
            right: 30px;
        }

        .bottom {
            flex-x(space-around);

            img {
                width: 48px;
                height: 48px;
                border-radius: 48px;
            }

            i {
                font-size: 30px;
                color: rgba(0, 0, 0, 0.45);
            }

            .el-textarea {
                width: 712px;
                min-height: 48px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(115, 176, 255, 1);
            }

            >>>.el-textarea__inner {
                min-height: 48px !important;
                height: 48px !important;
                border: 0px;
            }
        }
    }

    .chat-bottom::-webkit-scrollbar {
        display: none;
    }

    .chat-upload {
        flex-x(flex-start, flex-end);

        p {
            margin-left: 15px;
            font-size: 10px;
            color: rgba(0, 0, 0, 0.45);
        }
    }

    .defaultImg {
        width: 160px !important;
        height: 120px !important;
    }
</style>
